module.exports = {
      id: "arrow-left-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }